import { useMemo } from 'react';
import sortBy from 'lodash/sortBy';

import { PrintProps } from '../multiple-choice.constants';
import SubActivityPrint from '../../sub-activity/sub-activity-print';
import { canShowOptionLetter } from '../multiple-choice.utils';
import { isSingleSelect } from '../logic/is-single-select';
import { MultipleChoiceLetter } from '../multiple-choice';
import MultipleChoicePrintRadio from './multiple-choice-print-radio';
import MultipleChoicePrintCheck from './multiple-choice-print-check';
import * as Styled from './multiple-choice-print-list.style';

const MultipleChoicePrintList = ({
  properties,
  subActivityProperties,
  showAnswer,
}: PrintProps & {
  showAnswer?: boolean;
}) => {
  const { multipleChoice } = properties;

  const sortedOptions = useMemo(() => sortBy(multipleChoice.options, 'sort'), [
    multipleChoice.options,
  ]);

  const isOneOptionCorrect = useMemo(
    () =>
      isSingleSelect({
        answerMode: multipleChoice.answerMode,
        isFreeAnswerMultiSelect: multipleChoice.isFreeAnswerMultiSelect,
        options: multipleChoice.options,
      }),
    [multipleChoice]
  );

  return (
    <SubActivityPrint subActivityDetails={subActivityProperties}>
      <Styled.MultipleChoicePrintList>
        {sortedOptions.map((option, index) => {
          const content = (
            <>
              {canShowOptionLetter(
                properties.multipleChoice.showOptionLetter
              ) && (
                <MultipleChoiceLetter
                  data-selector="multiple-choice-letter"
                  index={index}
                />
              )}
              <Styled.MultipleChoicePrintListText>
                {option.text}
              </Styled.MultipleChoicePrintListText>
            </>
          );
          return isOneOptionCorrect ? (
            <MultipleChoicePrintRadio
              label={content}
              key={index}
              showAnswer={showAnswer}
              isCorrect={option.correctAnswerBoolean}
            />
          ) : (
            <MultipleChoicePrintCheck
              label={content}
              key={index}
              showAnswer={showAnswer}
              isCorrect={option.correctAnswerBoolean}
            />
          );
        })}
      </Styled.MultipleChoicePrintList>
    </SubActivityPrint>
  );
};

export default MultipleChoicePrintList;
